import React, { useState, useEffect } from 'react'
import { Job_Tag_Box_Primary, Loader, WhiteBoxWrapper } from '../../constents/components'
import { Link, useNavigate } from 'react-router-dom';
import useFetchMultipleMocks from '../../Hooks/mockInterview/useFetchMultipleMocks';
import { alphanumericDate, howOldTimeUpdater } from '../../constents/functions';
import { useSelector } from 'react-redux';
import Modal from './Modal'
import useGenerateShareUrl from '../../Hooks/mockInterview/useGenerateShareUrl';
import useMockCredits from '../../Hooks/mockInterview/useMockCredits';




const Mock = ({ mock }) => {

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    // {
        // "Question_Preference": "easy",
        // "_id": "68b7ea1c2e405294d070f79c",
        // "mock_id": "43b769e8-f316-48e6-bf1d-26e9c2552cd7",
        // "Candidate_Id": "4690612b-bb7e-4351-9b00-3e2c699a9f5e",
        // "ResumeURL": "https://blobtalentai.blob.core.windows.net/storagezepcruit/a66d6de2-e13f-4b9f-8a39-2c535e7bbd1d.pdf",
        // "Skills": [
        //     "React",
        //     "js",
        //     "ts"
        // ],
        // "__v": 0,
        // "Title": "Automotive Engineer",
        // "Description": "Need a candidate who is willing to join early and ready to work 90 hours per week",
        // "Experience": 4,
        // "Values": "ethics"
    // }
    const mockTitle = mock?.Title;
    const mockDescription = mock?.Description?.slice(0, 200) + "...";
    const experience = mock?.Experience;
    const value = mock.Values;
    const skills = mock.Skills ?? [];
    const mockPostingTime = `Created on ${alphanumericDate(mock?.created_At)}`;
    // console.log("mock created time", mock?.created_At);

    const difficultyLevel = mock.Question_Preference;
    const mockId = mock?.mock_id;
    const appliedTime = mock?.created_At;
    // console.log("mock applied time", appliedTime);



    const Navigate = useNavigate();
    const goToMockSummaryPage = () => { };
    return (
        <WhiteBoxWrapper classes={'flex flex-col gap-2'}>

            {/* upper div */}
            <div className=" flex gap-2">

                <div className=' flex-1'>
                    <h2 className="text-black text-lg font-medium cursor-pointer hover:underline" onClick={() => goToMockSummaryPage()}>{mockTitle}</h2>
                </div>
            </div>

            <div className=' flex-1'>
                <div>
                    <div className=' flex gap-2 mt-1 flex-wrap'>{skills?.map((item, index) => (<Job_Tag_Box_Primary text={item} key={index} />))}</div>
                </div>
                <div className=' flex mt-2 gap-2'>
                    <p className='text-sm text-text-color-strong font-semibold'>
                        Difficulty:
                    </p>
                    <p className='text-sm text-text-color-strong'>
                        {capitalize(difficultyLevel)}
                    </p>
                </div>
                <div className=' flex mt-2 gap-2'>
                    <p className='text-sm text-text-color-strong font-semibold'>
                        Experience :
                    </p>
                    <p className='text-sm text-text-color-strong'>
                        {experience} years
                    </p>
                </div>

                <div className=' flex flex-col gap-1 py-2'>

                    {/* Job Description */}
                    <div className="text-gray-500 text-xs mb-4 line-clamp-2 flex-grow">
                        {mockDescription}
                    </div>
                </div>

                {/* View Details Button and Applied Date - Always at the bottom */}
                <div className="flex items-center justify-between mt-auto">
                    {mock?.Status === 'Question Generated' && (<button
                        onClick={() => Navigate(`/mock/mock-interview?mock_id=${mockId}`)}
                        className="bg-black text-white px-10 py-2 rounded-full text-xs font-medium"
                    >
                        Start Mock Interview
                    </button>)
                    }
                    {mock?.Status === "Process Completed" && (
                        <Link
                            to={`/mock/mock-review?mock_id=${mockId}`}
                            className="bg-black text-white px-10 py-2 rounded-full text-xs font-medium"
                        >
                            View FeedBack
                        </Link>
                    )}
                    {mock?.Status === 'failed' && (<button
                        onClick={() => {
                            alert("Your previous mock creation failed, don't worry, we did not deduct a token. Create a new mock.");
                            Navigate(`/mock/new-mock`)
                        }}
                        className="bg-red-500 text-white  px-10 py-2 rounded-full text-xs font-medium"
                    >
                        Error - ReCreate Mock
                    </button>)
                    }

                    {/* <div className="text-gray-400 text-xs">
                        {appliedTime && howOldTimeUpdater(appliedTime)}
                    </div> */}
                    <p className="text-xs md:text-xs flex justify-end">{mockPostingTime}</p>
                </div>
            </div>
        </WhiteBoxWrapper>

    );

}













const Index = () => {
    const navigate = useNavigate();
    const [loading, error, _, fetchMocks] = useFetchMultipleMocks();
    const [shareModalOpen, setShareModalOpen] = useState(false);
    // const [ledgerModalOpen, setLedgerModalOpen] = useState(false);
    // const [ledgerData, setLedgerData] = useState([]);
    // const [ledgerLoading, setLedgerLoading] = useState(false);
    // This state will hold the modified frontend share URL from backend token
    const [frontendShareUrl, setFrontendShareUrl] = useState('');
    const [showTooltip, setShowTooltip] = useState(false);

    const [shareLoading, shareError, backendShareUrl, generateShareUrl] = useGenerateShareUrl();
    const { credits, loading: creditsLoading, fetchCredits } = useMockCredits();
    useEffect(() => {
        // console.log("Mock page loaded, fetching mocks...");

        (async () => {
            // console.log("Inside async function to fetch mocks");
            if (!loading && fetchMocks) {
                // console.log("Fetching mocks...");
                try {
                    // console.log("Before fetchMocks call");
                    await fetchMocks();
                } catch (error) {
                    console.error("Error fetching mocks:", error);
                }
            }
        })();
    }, []);

    const mocks = useSelector(state => Object.values(state?.mocks ?? {}));
    const handleShareClick = () => {
        const confirmed = window.confirm("Are you sure to share an interview? This will deduct one token from your credits.")
        if (confirmed) {
            generateShareUrl();
        }
    }
    useEffect(() => {
        if (backendShareUrl) {
            try {
                const urlObj = new URL(backendShareUrl);
                const tokenParam = urlObj.searchParams.get('token');
                if (tokenParam) {
                    const frontendUrl = `${window.location.origin}/mock/redeem?token=${tokenParam}`;
                    setFrontendShareUrl(frontendUrl);
                    setShareModalOpen(true);
                    //refresh credits on share success that should not be the case
                }
            } catch (err) {
                console.error('Invalid backend share URL:', err);
                setFrontendShareUrl(backendShareUrl);
                setShareModalOpen(true);
            }
        }
    }, [backendShareUrl])
    return (
        <div className="min-h-screen pb-10">
            <div className="w-full">
                <div className="flex justify-end gap-4">
                    <button
                        onClick={() => navigate('/mock/new-mock/')}
                        className="relative bg-primary-color-900 text-white rounded-full text-sm lg:text-lg font-medium px-4 lg:px-6 py-2 flex items-center gap-2"
                    >
                        + Take mock test
                        <span
                            className="relative rounded-full bg-white text-black text-xs font-semibold h-6 w-6 flex items-center justify-center"
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                        >
                            {creditsLoading ? '...' : credits}
                            {showTooltip && (
                                <span className="absolute left-1/2 -translate-x-1/2 top-full mt-1 w-max whitespace-nowrap bg-primary-color-900 text-white text-xs rounded py-1 px-2 shadow-xl z-30">
                                    your credits : {credits}
                                </span>
                            )}
                        </span>
                    </button>

                    {/* Share Interview button */}
                    <button
                        onClick={handleShareClick}
                        className="rounded-full bg-green-600 text-white items-center gap-1 p-1 px-4 py-2 text-sm lg:text-base font-medium hover:bg-green-700 transition-colors duration-200"
                        disabled={shareLoading}
                    >
                        {shareLoading ? 'Generating Link...' : 'Share Interview'}
                    </button>

                    {/* Ledger button */}
                    <button
                        onClick={() => alert('Ledger feature coming soon!')}
                        className="rounded-full bg-blue-600 text-white items-center gap-1 p-1 px-4 py-2 text-sm lg:text-base font-medium hover:bg-blue-700 transition-colors duration-200"
                    >
                        Ledger
                    </button>
                </div>

                <div className="mt-2 rounded-xl overflow-hidden">
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {mocks.map((item, index) => (
                                <Mock mock={item} key={index} />
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Share Modal */}
            <Modal
                isOpen={shareModalOpen}
                onClose={() => setShareModalOpen(false)}
                shareLink={frontendShareUrl}
                title="Mock Interview"
            />
        </div>
    )
}

export default Index